import React from "react";
import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import FullCalendarWithModal from "../../../components/FullCalendar/FullCalendarWithModal";

const Calendario = () => {
  return (
    <Box p={{ base: 4, md: 8 }}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading color="secondary" fontSize={{ base: "3xl", md: "4xl" }}>
            Calendário
          </Heading>
        </Box>

        <FullCalendarWithModal />
      </VStack>
    </Box>
  );
};

export default Calendario;
